module.exports = "<div class=\"sticky-top\">\r\n\r\n  <div class=\"list-group\">\r\n    <a class=\"list-group-item list-group-item-action\" [class.active]=\"!category\" routerLink=\"/\">All Categories</a>\r\n    <a *ngFor=\"let c of categories$ | async\" routerLink=\"/\" [queryParams]=\"{ category: c.$key }\" class=\"list-group-item list-group-item-action\"\r\n      [class.active]=\"category === c.$key\">\r\n\r\n      {{ c.name }}\r\n    </a>\r\n\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/products/product-filter/product-filter.component.html
// module id = ../../../../../src/app/products/product-filter/product-filter.component.html
// module chunks = 1